import * as chainApi from "@hub/management/src/modules/chains/api/chain.api"
import createErrorMessage from "@shared/factories/src/errorMessage.factory"

export const listChains = async params => {
  try {
    return await chainApi.listChains(params)
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title: createErrorMessage(error).getMessage() || "Falha ao listar redes"
    })
    throw error
  }
}

export const listActiveChains = async params => {
  try {
    const { data } = await chainApi.listActiveChains(params)
    const chains = data.map(chain => ({
      ...chain,
      hasAccess: false,
      allPos: false
    }))
    return chains
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title: createErrorMessage(error).getMessage() || "Falha ao obter redes."
    })
  }
}

export const listChainsFromId = async params => {
  try {
    const { data } = await chainApi.listChainsFromId(params)
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title: createErrorMessage(error).getMessage() || "Falha ao obter redes."
    })
  }
}

export const changeStatus = async (uuid, params) => {
  try {
    await chainApi.changeStatus(uuid, params)
    window.$vue.$toast({
      type: "success",
      title: "Status alterado com sucesso."
    })
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title: createErrorMessage(error).getMessage() || "Falha ao trocar status"
    })
    throw error
  }
}

export const editChain = async (uuid, params) => {
  try {
    await chainApi.editChain(uuid, params)

    await window.$vue.$router.push({ name: "chain" })

    window.$vue.$toast({
      type: "success",
      title: "Rede editada com sucesso."
    })
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title: createErrorMessage(error).getMessage() || "Falha ao editar rede"
    })
    throw error
  }
}

export const fetchChain = async uuid => {
  try {
    return await chainApi.fetchChain(uuid)
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title: createErrorMessage(error).getMessage() || "Rede não encontrada"
    })
    throw error
  }
}

export const createChain = async params => {
  try {
    await chainApi.createChain(params)

    await window.$vue.$router.push({ name: "chain" })

    window.$vue.$toast({
      type: "success",
      title: "Rede cadastrada com sucesso."
    })
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title: createErrorMessage(error).getMessage() || "Falha ao cadastrar rede"
    })
    throw error
  }
}

export const getAllChain = async () => {
  try {
    const { data } = await chainApi.getAllChain()
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title: createErrorMessage(error).getMessage() || "Rede não encontrada"
    })
  }
}
